import { CommonEnums } from 'dashboard-services/api/common';
import { DataStorageEnums, GetDataBody, Key } from 'dashboard-services/api/dataStorage';
import { ActionService, ColorService, CommonService } from 'dashboard-services/services';
import TimeService from 'dashboard-services/services/TimeService';
import { globalActions } from 'primary-components';

import properties from 'resources/constants/properties.json';

import { builderDataStorageCreatorActions } from './';

import dayjs from 'dayjs';

export default (() => {
  const fillTypesWithAvgPointAmount = [DataStorageEnums.FILL_OPTION.DAYS_AVG_REL, DataStorageEnums.FILL_OPTION.VALUES_AVG_LAST_VAL, DataStorageEnums.FILL_OPTION.VALUES_AVG_REL]

  const CHANGE_VALUE = 'CHANGE_VALUE_RESULTS_DATA_STORAGE'
  const changeValue = ActionService.makeActionCreator(CHANGE_VALUE, 'value', 'name')

  const getBodyWithKeys = basket => {
    const builder = new GetDataBody.Builder()
    basket.forEach(basketItem => {
      let fillType = basketItem.fillType
      if(fillTypesWithAvgPointAmount.includes(basketItem.fillType) && (basketItem.avgPointsAmount === "" || basketItem.avgPointsAmount === undefined)) {
        fillType = undefined;
      }
      const shouldIncludeOffset = basketItem.offsetType !== undefined && basketItem.offsetAmount !== undefined && CommonService.isNumeric(basketItem.offsetAmount) && !String(basketItem.offsetAmount).includes(".")
      const key = new Key.Builder()
        .withColumns(basketItem?.choosenColumns.find(c => c?.value === "*") ? undefined : basketItem?.choosenColumns.map(e => e.value))
        .withSymbols(basketItem.symbols)
        .withMetadatas(basketItem.pattern ? basketItem.metadata : undefined)
        .withGroupName(basketItem.groupName)
        .withType(basketItem.type)
        .withFillType(fillType)
        .withAvgPointsAmount(fillType && fillTypesWithAvgPointAmount.includes(basketItem.fillType) ? basketItem.avgPointsAmount : undefined)
        .withOffsetType(shouldIncludeOffset ? basketItem.offsetType : undefined)
        .withOffsetAmount(shouldIncludeOffset ? basketItem.offsetAmount : undefined)
        .withPattern(basketItem.pattern)
        .withPatternExactMatch(basketItem.patternExactMatch)
        .withSymbolValuesExactMatch(basketItem.symbolValuesExactMatch)
        .withSource(basketItem.source)
      builder.withKey(key.build().serialize())
    })
    return builder
  }

  const getTsGetDataBodyRaw = ({ outputFormat, stats = false, basket, dataRange, deltaTransDateLimitType, deltaTransDateLimitAmount, lastType, lastValue, lastTypeOnTime, holidayCalendar, lastTypeOnTimeTimezone, to, toTime, from, fromTime, fromSelected, toSelected, timezone, decimalPlaces, skipEmptyColumns, delta, roundingMode, dateFormat, onDateTimeOn, onDateTimeDate, onDateTimeTime, corrections, withWareHouseService }) => (dispatch, getState) => {
    const isGroupFilterApplied = builderDataStorageCreatorActions.isGroupFilterApplied(basket),
          definedTime = getState().myAccountState.settingsState.definedTime

    let builder = isGroupFilterApplied ? new GetDataBody.Builder().withGroupName(basket[0]?.groupName) : getBodyWithKeys(basket)
    if (onDateTimeOn) {
      const date = (onDateTimeDate || TimeService.getCurrentDate(definedTime)) + "T" + (onDateTimeTime || "23:59:59.000")
      builder = builder.withOnDateTime(TimeService.getUTCDateTime(date, definedTime))
    }
    if(dataRange === DataStorageEnums.DATA_RANGE.BETWEEN) {
      builder = builder
              .withStartDate(fromSelected === DataStorageEnums.DATE_BETWEEN_TYPE.DATE ? dayjs(from + (fromTime ? "T" + fromTime : "T00:00:00.000")).format(TimeService.ISO_DATE_TIME_FORMAT_BACKEND_WITH_SECONDS_STYLE) : fromSelected)
              .withEndDate(toSelected === DataStorageEnums.DATE_BETWEEN_TYPE.DATE ? dayjs(to  + (toTime ? "T" + toTime : "T23:59:59.999")).format(TimeService.ISO_DATE_TIME_FORMAT_BACKEND_WITH_SECONDS_STYLE) : toSelected)
    }
    if(outputFormat) {
      builder = builder.withFormatType(outputFormat)
    }

    if(dataRange === DataStorageEnums.DATA_RANGE.LAST || dataRange === DataStorageEnums.DATA_RANGE.NEXT) {
      builder = builder
              .withLastType(lastType)
              .withLastTypeAmount(lastValue)
              .withLastTypeOnTime(lastTypeOnTime)
              .withLastTypeOnTimeTimezone(lastTypeOnTimeTimezone)
              .withHolidayCalendar(holidayCalendar)
    }

    if((dataRange === DataStorageEnums.DATA_RANGE.LAST || dataRange === DataStorageEnums.DATA_RANGE.NEXT || dataRange === DataStorageEnums.DATA_RANGE.BETWEEN) && (deltaTransDateLimitType && deltaTransDateLimitAmount)) {
      builder = builder
              .withDeltaTransDateLimitType(deltaTransDateLimitType)
              .withDeltaTransDateLimitAmount(deltaTransDateLimitAmount)
    }

    if(withWareHouseService) {
      builder = builder
              .withSource("WarehouseService")
    }

    const body = builder
      .withRange(dataRange)
      .withDateFormat(dateFormat)
      .withCorrections(corrections)
      .withIncludeFileId(corrections !== "false" && outputFormat === undefined)
      .withTimeZone(timezone)
      .withDecimalPrecision(decimalPlaces === "" ? undefined : decimalPlaces)
      .withRoundingMode(roundingMode)
      .withSkipEmptyColumns(skipEmptyColumns)
      .withDelta(delta)
      .withStats(stats)
      .build()
      .serialize()
    return body
  }

  const getTsGetDataBody = ({ outputFormat = undefined, stats = false } = {}) => (dispatch, getState) => dispatch(getTsGetDataBodyRaw({ ... getState().dataStorageState.creatorState.builderState, outputFormat, stats }))

  const localColors = [
    "#FFB951", "#00A6A6", "#ADDAFF", "#F9C3A2", "#EAC9C1", "#FBAFAF", "#F0F374", "#FBEBAF", "#FFDA51"
  ]

  const SUPPORTED_EXCEL_FIELDS = ["timeZone", "range", "startDate", "endDate", "lastType", "lastTypeAmount", "dateFormat", "avgPointsAmount", /*formatType*/] // format type will differ
  const createExcelFormula = () => (dispatch, getState) => {
    const { basket, order } = getState().dataStorageState.creatorState.builderState,
          isGroupFilterApplied = builderDataStorageCreatorActions.isGroupFilterApplied(basket)

    const body =  dispatch(getTsGetDataBody())
    let formula = `=${properties.functionsNamespace}.GET.TS(`
    if(!isGroupFilterApplied) {
      formula += body.keys.map(key => {
        const symbols = Object.entries(key.symbols).map(([key, value ]) => `""${key}"":""${value}""`).join(","),
              metadatas = Object.entries(key.metadatas).map(([key, value ]) => `""${key}"":""${value}""`).join(","),
              localSource = key?.source ? key.source : getState().globalState.providers.find(provider => provider.producerId === 0)?.name,
              localFormula = `"groupName=${key.groupName}","symbols=""{${symbols}}""","metadatas=""{${metadatas}}""", "columns=${key.columns.join(",")}", "source=${localSource}"`
        return localFormula;
      }).join(",")
    }  else {
      formula = `"groupName=${body.keys[0]?.groupName}", "symbols=""{}""", "columns=${body.keys[0]?.columns.join(",")}"`
    }
    formula += `,"order=${order}"`
    Object.entries(body).filter(([key, value]) => SUPPORTED_EXCEL_FIELDS.includes(key) && value !== undefined && value !== null && value !== "").forEach(([key, value]) => {
      formula += `,"${key}=${value}"`
    })
    formula += `)`
    return formula;
  }

  const getColumnLabel = value => `${Object.values(value.symbols).join(", ")} (${value.valueName})`

  const CLEAR_CHARTS = 'CLEAR_CHARTS_RESULTS_DATA_STORAGE'
  const clearCharts = ActionService.makeActionCreator(CLEAR_CHARTS)

  const getOrder = () => (_, getState) => getState().dataStorageState.creatorState.builderState.order || CommonEnums.SORT_ORDER.DESCENDING
  const generateCurl = () => (dispatch, getState) => {
    const basket = getState().dataStorageState.creatorState.builderState.basket
    const body = "-d '" + JSON.stringify(dispatch(getTsGetDataBody()))?.replace(/'T'/g, "'\\''T'\\''") + "'",
          beginning = "curl -X POST",
          url = properties.baseUrl.api + "/ts?size=-1&order=" + dispatch(getOrder()),
          auth = "-H 'Authorization: Bearer " +  getState().primaryComponentsState.loginState.token + "'",
          csvHeader = "-H 'Content-Type: text/csv' -H 'Accept: text/csv'",
          source = basket.find(i => i.source)?.source,
          sourceHeader = source ? ` -H 'Target: ${source}'` : '',
          curl = beginning + " " + auth + sourceHeader + " " + csvHeader + " " + body + " " + "'" + url + "'";
    return curl;
  }

  const downloadChart = (chart, name) => dispatch => {
    if(!chart || !chart.current) {
      return Promise.resolve();
    }
    const reqId = CommonService.generateUID()
    dispatch(globalActions.handleRequest({ id: reqId }));
    return CommonService.svgToPng(chart.current.container.children[0], chart.current.container.children[0].clientWidth, chart.current.container.children[0].clientHeight)
      .then(res => CommonService.createAndDownloadGeneric(res.imageData, `${name}.png`))
      .catch(() => dispatch(globalActions.getMessageStore()).error("Can not create image. Too many data."))
      .finally(() => dispatch(globalActions.handleRequest({ id: reqId })))
  }

  const setUpStandardResponse = data => (dispatch, getState) => {
    const basket = getState().dataStorageState.creatorState.builderState.basket,
          isGroupFilterApplied = builderDataStorageCreatorActions.isGroupFilterApplied(basket)
    let index = -1;
    let lastPatternIndex = -2;
    dispatch(changeValue(data.values, 'values'))
    dispatch(changeValue(data.columns.map(col => {
      if(!isGroupFilterApplied && basket[col.inputIndex]?.pattern) {
        if(col.inputIndex !== lastPatternIndex) {
          index++;
          lastPatternIndex = col.inputIndex;
        }
        const localColorsLength = localColors.length
        if(localColorsLength === index) {
          index = 0;
        }
        return Object.assign(col, { color: localColors[index] })
      } else if(isGroupFilterApplied) {
        return Object.assign(col, { color: localColors[0] })
      }
      return col;
    }), 'columns'))
  }

  const setUpChartResponse = data => dispatch => {
    const colors = ColorService.getColors(Object.keys(data.symbols).length * 2)
    const newSymbols = new Map()
    Object.entries(data.symbols).forEach(([k, v], index) => {
      const value = Object.assign({}, v, { color: colors[index], secondaryColor: colors[index + Object.keys(data.symbols).length], label: getColumnLabel(v) })
      newSymbols.set(k, value)
    })
    dispatch(changeValue(data.values, "chartValues"))
    dispatch(changeValue(newSymbols, "chartColumns"))
    dispatch(changeValue(data.statistics, "statistics"))
    dispatch(changeValue(data.symbols, "statisticsSymbols"))
  }

  return {
    changeValue,
    CHANGE_VALUE,
    generateCurl,
    CLEAR_CHARTS,
    clearCharts,
    downloadChart,
    fillTypesWithAvgPointAmount,
    createExcelFormula,
    getTsGetDataBodyRaw,
    setUpStandardResponse,
    setUpChartResponse
  }
})()